import React from "react";
import classes from "./techOverview.module.scss";
import arrowIcon from "../../assets/arrow.svg";
import { Collapse } from "react-bootstrap";

const Fetch = ({ openTab, setOpenTab }) => {
  return (
    <>
      <button
        onClick={() => {
          if (openTab !== "Fetch") {
            setOpenTab("Fetch");
          } else setOpenTab(null);
        }}
        aria-controls="fetch-collapse-text"
        aria-expanded={openTab === "Fetch"}
        className={`${classes.btn} d-flex align-items-center justify-content-between pt-3 pb-2 px-0`}
      >
        Making API requests
        <img src={arrowIcon} alt="" style={{ width: "12px" }} />
      </button>
      <Collapse in={openTab === "Fetch"}>
        <div id="fetch-collapse-text" className={classes.content}>
          <p>
            All API calls should have the following endpoint:{" "}
            <a
              href={`https://${window.location.hostname}/json.rpc`}
              className={classes.link}
            >{`https://${window.location.hostname}/api/service/EUeInvoices.<API>`}</a>
          </p>
          <p>
            As previously mentioned, authenticating with every call is
            mandatory. Your authentication credential is the connection key
            (which can be found in the dashboard). Please note that you may have
            two connection keys - a TEST and a PRODUCTION one, as explained
            under the "Authentication" section above.
          </p>
          <p>
            You can add the connection key to the call by configuring the header
            of the request in the following way:
          </p>
          <pre>
            <code>
              headers&#58; &#123;
              <br />
              &nbsp;&nbsp;Authorization&#58; 'IoT
              &lt;connectionKey&gt;:&lt;projectName&gt;'
              {/* <br />
              &nbsp;&nbsp;'D3Pro-PreferAuthorizationOverSession'&#58; 'True' */}
              <br />
              &#125;
            </code>
          </pre>
          <p>
            Note that the header{" "}
            <span className={classes["connection-key"]}>
              D3Pro-PreferAuthorizationOverSession
            </span>{" "}
            must be included and set to 'True' in order for the connection key
            to be properly recognized.
          </p>
          <p>
            In the end, your call should be configured in the following way:
          </p>
          <pre>
            <code>
              fetch(&quot;https://dddinvoices.com/api/service/EUeInvoices.&#60;API&#62;&quot;,
              &#123;
              <br />
              &nbsp;&nbsp;method: &quot;Extension.Execute&quot;,
              <br />
              &nbsp;&nbsp;credentials: &quot;omit&quot;,
              <br />
              &nbsp;&nbsp;headers: &#123;
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&quot;Content-Type&quot;:
              &quot;application/json&quot;,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;Authorization: &quot;IoT
              &#60;ConnKey&#62;:EUeInvoices&quot;,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&quot;D3Pro-PreferAuthorizationOverSession&quot;:
              &quot;True&quot;,
              <br />
              &nbsp;&nbsp;&#125;,
              <br />
              &nbsp;&nbsp;body: &#47;&#47; place the request object here
              <br />
              &#125;, &#123;
              <br />
              &nbsp;&nbsp;Authorization: &quot;IoT
              &#60;ConnKey&#62;:EUeInvoices&quot;,
              <br />
              &nbsp;&nbsp;&quot;D3Pro-PreferAuthorizationOverSession&quot;:
              &quot;True&quot;,
              <br />
              &#125;).then(result &#61;&#62; &#123; &#47;&#47; define function
              here &#125;)
              <br />
              &nbsp;&nbsp;
            </code>
          </pre>
        </div>
      </Collapse>
    </>
  );
};

export default Fetch;
